/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../clients/axios.ts";
import type { RequestConfig, ResponseErrorConfig } from "../../../clients/axios.ts";
import type { DeleteApiJingleCollectionsIdMutationResponse, DeleteApiJingleCollectionsIdPathParams, DeleteApiJingleCollectionsId400, DeleteApiJingleCollectionsId401, DeleteApiJingleCollectionsId403, DeleteApiJingleCollectionsId404, DeleteApiJingleCollectionsId500 } from "../../types/DeleteApiJingleCollectionsId.ts";
import { deleteApiJingleCollectionsIdMutationResponseSchema } from "../../zod/JingleCollectionSchemas/deleteApiJingleCollectionsIdSchema.ts";

function getDeleteApiJingleCollectionsIdUrl({ id }: { id: DeleteApiJingleCollectionsIdPathParams["Id"] }) {
  const res = { method: 'DELETE', url: `/api/jingle-collections/${id}` as const }  
  return res
}

/**
 * @summary Удаление подборки джинглов
 * {@link /api/jingle-collections/:Id}
 */
export async function deleteApiJingleCollectionsId({ id }: { id: DeleteApiJingleCollectionsIdPathParams["Id"] }, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<DeleteApiJingleCollectionsIdMutationResponse, ResponseErrorConfig<DeleteApiJingleCollectionsId400 | DeleteApiJingleCollectionsId401 | DeleteApiJingleCollectionsId403 | DeleteApiJingleCollectionsId404 | DeleteApiJingleCollectionsId500>, unknown>({ method : "DELETE", url : getDeleteApiJingleCollectionsIdUrl({ id }).url.toString(), ... requestConfig })  
  return deleteApiJingleCollectionsIdMutationResponseSchema.parse(res.data)
}